export function GetMockCaseQueryRead() {
  return {
    id: 87,
    queryDate: "2022-11-30T11:37:38.1466667",
    queryUpdatedDate: "2022-11-30T11:37:38.1466667",
    querySubject: "Test",
    queryText: "Testing from third party API",
    caseId: 1881,
    fromUserId: 438,
    respondedTo: 0,
    isDeleted: 0,
    isClosed: 0,
    closedDate: "0001-01-01T00:00:00",
  };
}
